module.exports = __webpack_public_path__ + "static/media/2024-Retire-Ready-Feature-banner-lg@2x.4891461b.jpg";